export const mockData = {
  requests: {
    assets: [
      {
        id: 1,
        category: 'Asset',
        title: 'IPad Test device',
        content: 'John requested New iPad for testing',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          assignDate: '2024-01-02T07:24:17.000000Z',
          returnDate: '2024-01-15T07:24:17.000000Z',
          name: 'iPad Pro 2023',
        }),
      },
      {
        id: 2,
        category: 'Asset',
        title: 'New Macbook Pro',
        content: 'Mark requested a new Macbook Pro 2023',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          assignDate: '2024-05-01T07:24:17.000000Z',
          returnDate: '2024-06-01T07:24:17.000000Z',
          name: 'Macbook Pro 2023',
        }),
      },
    ],
    compensation: [
      {
        id: 1,
        category: 'Compensation',
        title: 'Paternal Compensation',
        content: 'John requested a paternal compensation',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          startDate: '2024-01-02T07:24:17.000000Z',
          endDate: '2024-01-15T07:24:17.000000Z',
          name: 'Paternal Compensation',
          type: 'Paternal',
          compensationValue: '5000',
        }),
      },
      {
        id: 2,
        category: 'Compensation',
        title: 'Maternal Compensation',
        content: 'Angela requested a maternal compensation',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          startDate: '2024-05-01T07:24:17.000000Z',
          endDate: '2024-06-01T07:24:17.000000Z',
          name: 'Maternal Compensation',
          type: 'Maternal',
          compensationValue: '10000',
        }),
      },
    ],
    employmentStatus: [
      {
        id: 1,
        category: 'EmploymentStatus',
        title: 'Employment Status',
        content: 'Robert employment status change request',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          date: '2024-01-02T07:24:17.000000Z',
          currentStatus: 'Junior',
          newStatus: 'Middle',
        }),
      },
      {
        id: 2,
        category: 'EmploymentStatus',
        title: 'Employment Status',
        content: 'Emily employment status change request',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          date: '2024-05-01T07:24:17.000000Z',
          currentStatus: 'Middle',
          newStatus: 'Senior',
        }),
      },
    ],
    jobInfo: [
      {
        id: 1,
        category: 'JobInformation',
        title: 'Job information change',
        content: 'Ernest hire date change request',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          hireDate: '2024-01-02T07:24:17.000000Z',
          jobTitle: 'Engineer',
          currentJobTitle: 'Candidate',
        }),
      },
      {
        id: 2,
        category: 'JobInformation',
        title: 'Job information change',
        content: 'George job title change request',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          hireDate: '2024-01-02T07:24:17.000000Z',
          jobTitle: 'Team Lead',
          currentJobTitle: 'Senior Engineer',
        }),
      },
    ],
    promotion: [
      {
        id: 1,
        category: 'Promotion',
        title: 'Promotion Request',
        content: 'Elon requested promotion',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          hireDate: '2024-01-02T07:24:17.000000Z',
          jobTitle: 'Engineer',
          currentJobTitle: 'Candidate',
        }),
      },
      {
        id: 2,
        category: 'Promotion',
        title: 'Promotion Request',
        content: 'George requested promotion',
        created_at: '2024-01-02T07:24:17.000000Z',
        data: JSON.stringify({
          hireDate: '2024-01-02T07:24:17.000000Z',
          jobTitle: 'Team Lead',
          currentJobTitle: 'Senior Engineer',
        }),
      },
    ],
  },
  globalSearch: [
    { type: 'Employee', name: 'Alice' },
    { type: 'Settings', name: 'Survey' },
    { type: 'Employee', name: 'Charlie' },
    { type: 'Hiring', name: 'David' },
    { type: 'Employee', name: 'Eva' },
    { type: 'Hiring', name: 'Frank' },
    { type: 'Settings', name: 'Onboarding' },
    { type: 'Employee', name: 'Grace' },
    { type: 'Hiring', name: 'Helen' },
    { type: 'Employee', name: 'Ian' },
    { type: 'Hiring', name: 'Jack' },
    { type: 'Employee', name: 'Kelly' },
    { type: 'Hiring', name: 'Liam' },
    { type: 'Employee', name: 'Mia' },
    { type: 'Hiring', name: 'Nathan' },
    { type: 'Employee', name: 'Olivia' },
  ],
};
